import React from 'react';
import { motion } from 'framer-motion';

const periods = [
  { value: 'today', label: 'Today' },
  { value: '7d', label: '7 days' },
  { value: '30d', label: '30 days' },
  { value: '90d', label: '90 days' }
];

export function TimeRangeFilter({ value, onChange }) {
  return (
    <div className="inline-flex items-center bg-white border border-stone-200 rounded-xl p-1 shadow-sm">
      {periods.map((period) => (
        <button
          key={period.value}
          onClick={() => onChange(period.value)}
          className={`relative px-3.5 py-1.5 text-sm font-medium rounded-lg transition-colors ${
            value === period.value
              ? 'text-white'
              : 'text-gray-500 hover:text-gray-700'
          }`}
        >
          {value === period.value && (
            <motion.div
              layoutId="activeTab"
              className="absolute inset-0 bg-[#F2575F] rounded-lg shadow-sm"
              transition={{ type: 'spring', duration: 0.3 }}
            />
          )}
          <span className="relative z-10">{period.label}</span>
        </button>
      ))}
    </div>
  );
}

export default TimeRangeFilter;
